import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-muted px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-background shadow-sm sm:h-16 sm:w-16">
          <Compass className="h-7 w-7 text-primary sm:h-8 sm:w-8" aria-hidden />
        </div>

        <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground">404</p>
        <h1 className="mt-2 text-xl font-semibold text-foreground sm:text-2xl">Page not found</h1>

        <p className="mt-3 text-sm text-muted-foreground">
          There is nothing at this address. The link may be out of date, or the page may have moved.
        </p>

        <p className="mt-2 break-all text-xs text-muted-foreground/70">
          <span className="font-mono">{location.pathname}</span>
        </p>

        <div className="mt-6 flex flex-col items-center justify-center gap-2 sm:flex-row">
          <Button asChild className="w-full sm:w-auto">
            <Link to="/metrics/utilisation-rate">Go to dashboard</Link>
          </Button>
          <Button asChild variant="outline" className="w-full sm:w-auto">
            <Link to="/">Back to sign in</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
